







































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  IdrShetuJibing,
  IdrShetuGuanxi,
  IdrShetuFenxiGuize,
} from "@/request/kanban";
import TimeSelect from "../time-type-select.vue";
import { GetTerms } from "@/request/projects";
@Component({
  components: {
    TimeSelect,
  },
})
export default class KanbanIdrShetu extends Vue {
  @Prop()
  private selectedHospitals: any;
  @Prop()
  private center: any;
  private jibings: any[] = [];
  private selectedBing: any = {};
  private message: any = {
    舌图疾病分布: {},
    关系: {},
    分析规则: {},
  };
  private timeType: any = {
    舌图报告: "全部时间",
  };
  private customTime: any = {
    舌图报告: [],
  };
  private barOption: any = {
    title: {
      left: "center",
      textStyle: {
        fontWeight: "normal",
        fontSize: "14",
      },
    },
    xAxis: {
      type: "value",
    },
    yAxis: {
      type: "category",
      data: [],
    },
    grid: {
      left: "30%",
    },
    tooltip: {},
    series: [
      {
        type: "bar",
        data: [],
        label: {
          show: true,
        },
        itemStyle: {
          normal: {
            color: (params) => {
              const colorList = [
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
              ];
              let index = params.dataIndex;
              if (params.dataIndex >= colorList.length) {
                index = params.dataIndex - colorList.length;
              }
              return colorList[index];
            },
          },
        },
      },
    ],
  };
  private xiyi: any = {};
  private zhongyi: any = {};
  private zhengxing: any = {};
  private pieOption: any = {
    color: [
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
    ],
    title: {
      left: "center",
      bottom: "10%",
      text: "",
      textStyle: {
        fontWeight: "normal",
        fontSize: "16",
      },
    },
    tooltip: {},
    series: [
      {
        type: "pie",
        data: [],
        roseType: "radius",
        radius: ["0", "50%"],
      },
    ],
  };
  private shese: any = {};
  private shexing: any = {};
  private taise: any = {};
  private taizhi: any = {};
  private tezhengfenbu: any = {
    xAxis: {
      type: "category",
      data: [],
    },
    yAxis: {
      type: "value",
    },
    grid: {},
    tooltip: {},
    series: [
      {
        type: "bar",
        data: [],
        label: {
          show: true,
        },
        itemStyle: {
          normal: {
            color: (params) => {
              const colorList = [
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
                "#FFA7CC",
                "#46AAAA",
                "#FFAA6A",
                "#A185D3",
                "#82D1F1",
                "#EC7E68",
                "#F6C63C",
                "#7784A2",
                "#75DDB5",
                "#759FFC",
              ];
              let index = params.dataIndex;
              if (params.dataIndex >= colorList.length) {
                index = params.dataIndex - colorList.length;
              }
              return colorList[index];
            },
          },
        },
      },
    ],
  };
  private selectedZhengxing: any = "";
  private tezhengEi: any = {};
  private zhichidu: any = 20;
  private zhixindu: any = 80;
  private tezhengfenxi: any = {
    color: [
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
    ],
    tooltip: {},
    series: [
      {
        type: "pie",
        data: [],
        roseType: "radius",
        radius: ["0", "50%"],
      },
    ],
  };
  private guanlianguize: any = {
    color: [
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
      "#FFA7CC",
      "#46AAAA",
      "#FFAA6A",
      "#A185D3",
      "#82D1F1",
      "#EC7E68",
      "#F6C63C",
      "#7784A2",
      "#75DDB5",
      "#759FFC",
    ],
    tooltip: {},
    series: [
      {
        type: "graph",
        layout: "force",
        force: {
          repulsion: 1000,
        },
        label: {
          show: true,
        },
        data: [],
        links: [],
        categories: [],
      },
    ],
  };
  /**
   * @description 时间变化
   */
  private timeChange(type) {
    this.timeType["舌图报告"] = type;
  }
  /**
   * @description 时间自定义变化
   */
  private timeCustomChange(val) {
    this.customTime["舌图报告"] = val;
  }
  /**
   * @description 获取舌图疾病分布
   */
  private shetujibing() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
    };
    IdrShetuJibing(this, params).then((data: any) => {
      // console.log(data);
      this.message["舌图疾病分布"] = data;
      this.createBar();
    });
  }
  /**
   * @description 创建西医疾病，中医疾病，中医证型
   */
  private createBar() {
    this.xiyi = _.cloneDeep(this.barOption);
    this.xiyi["series"][0]["data"] = this.message["舌图疾病分布"][
      "按西医疾病分"
    ]["data"];
    this.xiyi["yAxis"]["data"] = this.message["舌图疾病分布"]["按西医疾病分"][
      "name"
    ];
    this.xiyi["title"]["text"] = "按西医疾病分";
    this.zhongyi = _.cloneDeep(this.barOption);
    this.zhongyi["series"][0]["data"] = this.message["舌图疾病分布"][
      "按中医疾病分"
    ]["data"];
    this.zhongyi["yAxis"]["data"] = this.message["舌图疾病分布"][
      "按中医疾病分"
    ]["name"];
    this.zhongyi["title"]["text"] = "按中医疾病分";
    this.zhengxing = _.cloneDeep(this.barOption);
    this.zhengxing["series"][0]["data"] = this.message["舌图疾病分布"][
      "按中医证型分"
    ]["data"];
    this.zhengxing["yAxis"]["data"] = this.message["舌图疾病分布"][
      "按中医证型分"
    ]["name"];
    this.zhengxing["title"]["text"] = "按中医证型分";
  }
  /**
   * @description 搜索疾病
   */
  private searchJibing(ev) {
    const params: any = {
      params: {
        type: "西医疾病",
        search: ev,
      },
    };
    GetTerms(this, params).then((data: any) => {
      this.jibings = data;
    });
  }
  /**
   * @description 舌图对应疾病的关系
   */
  private guanxi() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      西医疾病: this.selectedBing,
    };
    IdrShetuGuanxi(this, params).then((data: any) => {
      this.message["关系"] = data;
      this.createPie();
      this.createTezhengfenbu();
    });
  }
  /**
   * @description 创建舌图对应疾病的关系饼图
   */
  private createPie() {
    this.shese = _.cloneDeep(this.pieOption);
    this.shese["title"]["text"] = "舌色";
    this.shese["series"][0]["data"] = this.message["关系"]["舌色"]["data"];
    this.shexing = _.cloneDeep(this.pieOption);
    this.shexing["title"]["text"] = "舌形";
    this.shexing["series"][0]["data"] = this.message["关系"]["舌形"]["data"];
    this.taise = _.cloneDeep(this.pieOption);
    this.taise["title"]["text"] = "苔色";
    this.taise["series"][0]["data"] = this.message["关系"]["苔色"]["data"];
    this.taizhi = _.cloneDeep(this.pieOption);
    this.taizhi["title"]["text"] = "苔质";
    this.taizhi["series"][0]["data"] = this.message["关系"]["苔质"]["data"];
  }
  /**
   * @description 创建舌形特征分布柱状图
   */
  private createTezhengfenbu() {
    this.tezhengfenbu["series"][0]["data"] = this.message["关系"]["各证型分布"][
      "data"
    ];
    this.tezhengfenbu["xAxis"]["data"] = this.message["关系"]["各证型分布"][
      "name"
    ];
    this.tezhengEi.on("click", this.selectZhengxing);
  }
  /**
   * @description 重置分析和规则
   */
  private resetFenxiGuize() {
    this.selectedZhengxing = "";
    this.fenxiGuize();
  }
  /**
   * @description 选择证型
   */
  private selectZhengxing(ev) {
    this.selectedZhengxing = ev.name;
    this.fenxiGuize();
  }
  /**
   * @description 获取舌图特征分析和舌图特征关联规则
   */
  private fenxiGuize() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      西医疾病: this.selectedBing,
      中医证型: this.selectedZhengxing,
      支持度: this.zhichidu,
      置信度: this.zhixindu,
    };
    IdrShetuFenxiGuize(this, params).then((data: any) => {
      this.message["分析规则"] = data;
      this.createTezhengfenxi();
      this.createGuize();
    });
  }
  /**
   * @description 创建舌图特征分析饼图
   */
  private createTezhengfenxi() {
    this.tezhengfenxi["series"][0]["data"] = this.message["分析规则"][
      "舌图特征分析"
    ]["data"];
  }
  /**
   * @description 创建舌图特征关联规则
   */
  private createGuize() {
    this.guanlianguize["series"][0]["links"] = this.message["分析规则"][
      "舌图关联规则"
    ]["links"];
    this.guanlianguize["series"][0]["data"] = this.message["分析规则"][
      "舌图关联规则"
    ]["nodes"];
    this.guanlianguize["series"][0]["categories"] = this.message["分析规则"][
      "舌图关联规则"
    ]["categories"];
  }
  /**
   * @description 重新计算关联规则
   */
  private recalGuize() {
    this.fenxiGuize();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.shetujibing();
        this.guanxi();
        this.fenxiGuize();
      },
      {
        immediate: true,
      }
    );
  }
}
